import { Button, Dialog, DialogActions, DialogContent, Stack } from "@mui/material";
import { bhpButtonSx } from "../../styles/bhpStyles";
import { DialogTitleClosable } from "../DialogTitleClosable";
import GroupIcon from '@mui/icons-material/Group';
import { useContext } from "react";
import VspPortalContext from "../../store/VspPortalContext";


type SecurityGroupsDialogProps = {

    dialogOpen: boolean;
    handleOk: ( ) => void;

};


export const SecurityGroupsDialog : React.FC< SecurityGroupsDialogProps > = ( props : SecurityGroupsDialogProps ) => {

    const { dialogOpen, handleOk } = props;

    const { state } = useContext( VspPortalContext );


    const handleClose = ( ) => handleOk( );


    const handleOkClick = ( ) => handleOk( );


    return(

        <Dialog
            onClose={ handleClose }
            open={ dialogOpen }
            sx={{ '& .MuiDialog-paper': { maxHeight: 435, width: '500px' } }}
        >
            <DialogTitleClosable onClose={ handleClose }>
                <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 }>
                    <GroupIcon /> Security Groups
                </Stack>
            </DialogTitleClosable>

            <DialogContent dividers>
                
                You are a member of the following security groups:
                <ul>

                    { 
                        state.userGroups.map( group => <li key={ group }>{ group } </li>) 
                    }

                </ul>

            </DialogContent>
            <DialogActions>
                <Button onClick={ handleOkClick } sx={{ ...bhpButtonSx, width: '100px' }} >
                    Ok
                </Button>
            </DialogActions>

        </Dialog>

    );



};